import React from 'react';
const items = [{
  name: 'Pack 6 Tomos Curriculares (1.º a 6.º)',
  value: '$97'
}, {
  name: 'Banco de Evaluaciones & Recursos Visuales',
  value: '$57'
}, {
  name: '6 Bonus Exclusivos de gestión docente',
  value: '$49'
}];
export function PricingSection() {
  return <section id="pricing" className="w-full bg-bg-dark py-14 sm:py-28 px-4 sm:px-6 relative overflow-hidden" data-id="element-190">
      {/* Soft pastel glows */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/15 rounded-full blur-[150px] pointer-events-none" data-id="element-191"></div>
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-cta-green/10 rounded-full blur-[100px] pointer-events-none" data-id="element-192"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-193">
        <h2 className="text-3xl sm:text-6xl font-black text-text-main text-center mb-6 sm:mb-16 tracking-tight" data-id="element-194">
          💰 Oferta Especial de Lanzamiento
        </h2>

        {/* Featured Card */}
        <div className="bg-bg-alt rounded-xl sm:rounded-3xl border border-primary/30 shadow-[0_20px_60px_-20px_rgba(37,99,235,0.35)] px-5 py-7 sm:p-14 flex flex-col relative w-full sm:w-[90%] mx-auto" data-id="element-195">
          <div className="absolute -top-3 sm:-top-5 left-1/2 -translate-x-1/2 bg-gradient-to-r from-secondary to-[#FBBF24] text-white font-black text-[10px] sm:text-base px-4 sm:px-8 py-1 sm:py-2.5 rounded-full whitespace-nowrap shadow-[0_8px_20px_rgba(245,158,11,0.4)]" data-id="element-196">
            ⭐ LA OPCIÓN DEFINITIVA PARA EL DOCENTE
          </div>

          <p className="text-sm sm:text-3xl font-black text-text-main text-center mt-2 sm:mt-4 mb-3 sm:mb-10 tracking-wide" data-id="element-197">
            CONTENIDOS DEL MEGAPACK:
          </p>

          {/* Compact list on mobile */}
          <div className="space-y-2 sm:space-y-5 mb-4 sm:mb-10 text-sm sm:text-xl" data-id="element-198">
            {items.map((item, i) => <div key={i} className="flex justify-between text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-199">
                <span data-id="element-200">{item.name}</span>
                <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-201">
                  {item.value}
                </span>
              </div>)}
            <div className="flex justify-between text-text-main font-black pt-1 sm:pt-4 text-base sm:text-2xl" data-id="element-202">
              <span data-id="element-203">VALOR TOTAL:</span>
              <span className="text-badge-red line-through" data-id="element-204">US$ 203</span>
            </div>
          </div>

          <p className="text-center text-text-sec text-xs sm:text-sm font-medium mb-4 sm:mb-6 max-w-xl mx-auto leading-relaxed" data-id="element-205">
            🌎 <span className="font-bold text-text-main" data-id="element-206">Pago seguro:</span> al
            hacer clic, verás el precio convertido a tu moneda nacional de forma
            automática y segura. Recibe el material para todos los años
            escolares de una sola vez.
          </p>

          <span className="inline-flex items-center justify-center gap-1.5 text-secondary font-bold text-[10px] sm:text-sm bg-secondary/15 px-3 py-1 sm:px-4 sm:py-1.5 rounded-full border border-secondary/30 animate-pulse mx-auto mb-4 sm:mb-6" data-id="element-207">
            ⏰ Precio de lanzamiento — sube pronto
          </span>

          {/* Price reveal — sits directly above the CTA */}
          <div className="text-center mb-4 sm:mb-6 bg-gradient-to-b from-primary/8 to-transparent border border-primary/20 py-4 sm:py-8 rounded-xl sm:rounded-2xl relative overflow-hidden" data-id="element-208">
            <div className="absolute top-0 left-0 w-full h-0.5 sm:h-1 bg-gradient-to-r from-transparent via-primary to-transparent" data-id="element-209"></div>
            <p className="text-primary font-bold mb-1 sm:mb-4 text-xs sm:text-lg" data-id="element-210">
              Precio Especial Hoy (91% OFF):
            </p>
            <div className="text-text-main font-black text-5xl sm:text-8xl tracking-tighter leading-none flex items-center justify-center gap-2 sm:gap-4" data-id="element-211">
              <span data-id="element-212">🏆</span>
              <span data-id="element-213">USD 17</span>
            </div>
            <div className="text-text-sec sm:text-base font-medium mt-1 text-[14px] sm:text-base" data-id="element-214">
              (Pagas en tu MONEDA LOCAL)
            </div>
          </div>

          <a href="https://matematicalista.impultienda.ar/checkout" onClick={() => {
          const w = window as any;
          if (w.fbq) {
            w.fbq('track', 'AddToCart', {
              content_name: 'MegaPack Matemática Lista',
              content_type: 'product',
              value: 17.0,
              currency: 'USD'
            });
          }
        }} className="btn-primary-pulse block w-full text-center bg-cta-green text-white font-black text-xl sm:text-3xl py-5 sm:py-8 rounded-2xl hover:bg-cta-green-hover transition-all shadow-[0_15px_40px_-10px_rgba(34,197,94,0.5)] mb-3 sm:mb-6 tracking-tight" data-id="element-215">
            🚀 ¡SÍ! QUIERO MI ACCESO AHORA
          </a>

          <p className="text-center text-text-sec text-[10px] sm:text-sm font-medium mb-2 sm:mb-8 flex items-center justify-center gap-1.5 sm:gap-3 flex-wrap" data-id="element-216">
            <span data-id="element-217">💳 Pago único</span>
            <span data-id="element-218">•</span>
            <span data-id="element-219">⚡ Acceso inmediato</span>
            <span data-id="element-220">•</span>
            <span data-id="element-221">🛡️ Garantía 7 Días</span>
          </p>
        </div>
      </div>
    </section>;
}